import {
  LayoutDashboard,
  Calendar as CalendarIcon,
  Users,
  Scissors,
  BarChart3,
  Store,
  Receipt,
  Boxes,
  Clapperboard,
  Sparkles
} from 'lucide-react';
import { NavItem, Page, Appointment, Notification } from './src/types';
import { StoryTemplate } from './src/types/media';

export const LOGO_URL = "https://xsjxglmijhrkcnqwqhus.supabase.co/storage/v1/object/sign/public-assets/logo.png?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9iZjA5MGQ1MC00ZDFmLTRhMjYtYTE3Zi00Y2JmN2E5ZGExYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJwdWJsaWMtYXNzZXRzL2xvZ28ucG5nIiwiaWF0IjoxNzY0NjkxNDI5LCJleHAiOjE3OTYyMjc0Mjl9.xKIuXqYr16ccY-wYyPfNXer_HIWUaByoQ92Y9rodbdU";

export const PRIMARY_COLOR = "#D96C4F";

export const NAV_ITEMS: NavItem[] = [
  { id: Page.HOME, label: 'Home', icon: LayoutDashboard },
  { id: Page.CALENDAR, label: 'Calendario', icon: CalendarIcon },
  { id: Page.CUSTOMERS, label: 'Clienti', icon: Users },
  { id: Page.STAFF, label: 'Dipendenti', icon: Scissors },
  { id: Page.ANALYTICS, label: 'Analytics', icon: BarChart3 },
  { id: Page.ASSISTANT, label: 'Assistente AI', icon: Sparkles },
  { id: Page.SALON, label: 'Salone', icon: Store },
  { id: Page.BILLING, label: 'Fatturazione', icon: Receipt },
  { id: Page.MEDIA, label: 'Media Creation', icon: Clapperboard },
  { id: Page.INVENTORY, label: 'Magazzino', icon: Boxes },
];

export const UPCOMING_APPOINTMENTS: Appointment[] = [
  { id: '1', clientName: 'Giulia Rossi', service: 'Taglio & Piega', staffName: 'Marco', time: '10:00', duration: 60, type: 'cut', status: 'confirmed' },
  { id: '2', clientName: 'Luca Bianchi', service: 'Barba Luxury', staffName: 'Alessandro', time: '10:30', duration: 30, type: 'treatment', status: 'confirmed' },
  { id: '3', clientName: 'Elena Verdi', service: 'Colore Totale', staffName: 'Sara', time: '11:15', duration: 120, type: 'color', status: 'pending' },
  { id: '4', clientName: 'Marta Neri', service: 'Trattamento Keratina', staffName: 'Marco', time: '14:00', duration: 90, type: 'treatment', status: 'confirmed' },
  { id: '5', clientName: 'Sofia Gialli', service: 'Piega Gloss', staffName: 'Sara', time: '16:00', duration: 45, type: 'style', status: 'completed' },
];

export const REVENUE_DATA = [
  { name: 'Lun', value: 400 },
  { name: 'Mar', value: 300 },
  { name: 'Mer', value: 550 },
  { name: 'Gio', value: 450 },
  { name: 'Ven', value: 890 },
  { name: 'Sab', value: 1200 },
  { name: 'Dom', value: 200 },
];

export const MOCK_NOTIFICATIONS: Notification[] = [
  { id: '1', title: 'Nuova Prenotazione', message: 'Giulia Rossi ha prenotato un Taglio per Domani alle 10:00.', time: '2 min fa', type: 'success', read: false },
  { id: '2', title: 'Scorta in Esaurimento', message: 'Lo Shampoo Keratina è sotto la soglia minima (4 pezzi).', time: '1 ora fa', type: 'alert', read: false },
  { id: '3', title: 'Pagamento Ricevuto', message: 'Fattura #INV-005 saldata con successo.', time: '3 ore fa', type: 'info', read: true },
  { id: '4', title: 'Nuova Recensione', message: 'Luca A. ha lasciato 5 stelle su Google.', time: 'Ieri', type: 'success', read: true },
];

export const MEDIA_TEMPLATES = [
  { id: 1, title: 'Summer Promo', type: 'Story', bg: 'bg-orange-100' },
  { id: 2, title: 'New Haircut', type: 'Post', bg: 'bg-stone-100' },
  { id: 3, title: 'Product Launch', type: 'Reel', bg: 'bg-rose-50' },
  { id: 4, title: 'Before & After', type: 'Carousel', bg: 'bg-gray-100' },
];

export const STORY_TEMPLATES: StoryTemplate[] = [
  {
    id: 1,
    title: 'Pink Vibes',
    category: 'Quote',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'BE YOURSELF', subtitle: 'Il tuo stile, la nostra passione.', cta: '@salon' },
    overlayColor: 'bg-black/30'
  },
  {
    id: 2,
    title: 'Minimal White',
    category: 'Seasonal',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1560869713-7d0a29430803?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'SUMMER READY', subtitle: 'Proteggi i tuoi capelli', cta: 'Info in DM' },
    overlayColor: 'bg-black/30'
  },
  {
    id: 3,
    title: 'Urban Style',
    category: 'Event',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'DOMENICA APERTI', subtitle: 'Vienici a trovare', cta: 'Link in Bio' },
    overlayColor: 'bg-black/30'
  },
  {
    id: 4,
    title: 'Flash Promo',
    category: 'Promo',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: '-20% QUESTA SETTIMANA', subtitle: 'Solo su taglio e piega', cta: 'Prenota ora' },
    overlayColor: 'bg-black/40'
  },
  {
    id: 5,
    title: 'Barber Mood',
    category: 'Promo',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'UOMO & BARBA', subtitle: 'Pacchetto completo a prezzo speciale', cta: 'Scrivici in DM' },
    overlayColor: 'bg-black/40'
  },
  {
    id: 6,
    title: 'Color Glow',
    category: 'Product',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'NUOVO COLORE', subtitle: 'Scopri la linea colore in salone', cta: 'Chiedi info' },
    overlayColor: 'bg-black/30'
  },
  {
    id: 7,
    title: 'Product Focus',
    category: 'Product',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1526045478516-99145907023c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'HAIR CARE', subtitle: 'I prodotti che usiamo, ora in vendita', cta: 'Disponibili in salone' },
    overlayColor: 'bg-black/20'
  },
  {
    id: 8,
    title: 'Golden Hour',
    category: 'Quote',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1492106087820-71f1a00d2b11?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'GOOD HAIR, GOOD MOOD', subtitle: 'Inizia la settimana con stile', cta: '@salon' },
    overlayColor: 'bg-black/20'
  },
  {
    id: 9,
    title: 'Fresh Cut',
    category: 'Quote',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'NEW LOOK, NEW YOU', subtitle: 'Il cambio look che aspettavi', cta: 'Prenota il tuo' },
    overlayColor: 'bg-black/40'
  },
  {
    id: 10,
    title: 'Winter Care',
    category: 'Seasonal',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1519699047748-de8e457a634e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'INVERNO IN ARRIVO', subtitle: 'Trattamenti nutrienti per i tuoi capelli', cta: 'Scopri di più' },
    overlayColor: 'bg-black/30'
  },
  {
    id: 11,
    title: 'Opening Night',
    category: 'Event',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'SERATA EVENTO', subtitle: 'Ti aspettiamo in salone', cta: 'Riserva il posto' },
    overlayColor: 'bg-black/50'
  },
  {
    id: 12,
    title: 'Backstage',
    category: 'Event',
    mediaType: 'image',
    bgImage: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    defaultText: { title: 'DIETRO LE QUINTE', subtitle: 'Una giornata con il nostro team', cta: 'Seguici' },
    overlayColor: 'bg-black/30'
  }
];